import { render, staticRenderFns } from "./QuestionSavantPairingCode.vue?vue&type=template&id=11539186&"
import script from "./QuestionSavantPairingCode.vue?vue&type=script&lang=js&"
export * from "./QuestionSavantPairingCode.vue?vue&type=script&lang=js&"
import style0 from "./QuestionSavantPairingCode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports